export type WorksheetPlannerMetadata = {
  authoringRevisionId?: string | null
  semanticPlanSignature?: string | null
  physicalPlanSignature?: string | null
  bindingGeneration?: string | null
  budgetClass?: string | null
}

export const normalizeWorksheetPlannerMetadata = (
  raw: WorksheetPlannerMetadata | null | undefined,
): WorksheetPlannerMetadata | null => {
  if (!raw || typeof raw !== 'object') return null
  const normalized = {
    authoringRevisionId: String(raw.authoringRevisionId ?? '').trim() || null,
    semanticPlanSignature: String(raw.semanticPlanSignature ?? '').trim() || null,
    physicalPlanSignature: String(raw.physicalPlanSignature ?? '').trim() || null,
    bindingGeneration: String(raw.bindingGeneration ?? '').trim() || null,
    budgetClass: String(raw.budgetClass ?? '').trim() || null,
  }
  return Object.values(normalized).some(Boolean) ? normalized : null
}
